/* eslint-disable */
export default {
  mute: 'Dempen',
  unmute: 'Dempen uitschakelen',
  hangup: 'Ophangen',
  reject: 'Weigeren',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
